import React, { useState, useEffect, useContext } from "react"

import "App.scss"
import axios from "axios"
import { Button, MenuItem, Select, Box } from "@mui/material"
import { FlexRowContainer } from "components/AllHelpComponents"
import { useTranslation } from "react-i18next"
import i18n from "helpers/i18n"
import { baseURL } from "constants/constants"
import { languageButtons } from "../constants/languageButtons"
import { useTheme } from "@mui/material/styles"
import { useLocation } from "react-router-dom"
import queryString from "query-string"
import waiterImg from "images/waiter.png"
import generatedGitInfo from "helpers/generatedGitInfo.json"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import { CartContext } from "App"

export const Header = () => {
  const location = useLocation()
  const query = queryString.parse(location.search)
  const [isButtonDisabled, setButtonDisabled] = useState(false)
  const { gitCommitHash, timeCommitPushed, timeUploadingToNetlify } = generatedGitInfo
  const theme = useTheme()
  const { t } = useTranslation()
  const [isTestTextVisible, setTestTextVisible] = useState(false)
  const [formOpenSendWaiter, setFormOpenSendWaiter] = useState(false)
  const [successAlert, setSuccessAlert] = useState(false)
  const [errorAlert, setErrorAlert] = useState(false)

  const { settings, language, setLanguage, restaurant_id } = useContext(CartContext)

  console.log("settings222", settings)
  const toggleTestText = () => {
    setTestTextVisible(!isTestTextVisible)
  }

  const sendMessageTelegram = async () => {
    // @Cafe_Cafe_New_Bot
    // const token = "6545709213:AAGYnLVz279g_kuSq5NFIgfpM7wLlKe8R_0"

    // @burgerShopsBot
    // const token = "6325762933:AAGE2pWwGTNoLoqsh8ETOrxNLX8em0SYmCQ"

    // @Testing770Bot
    const token = "6134674568:AAEOCLFEBqjHhz82wa6AZqXuIrxgD3YECbU"

    const chatId = settings.adminNumberTelegram

    // const chatId = 386212074; // адресс кому посылаем

    const message = `send waiter to ${query.qr_name}`
    const url = `https://api.telegram.org/bot${token}/sendMessage`

    if (!chatId) {
      console.error("Chat ID is not defined")
      setErrorAlert(true)
      setTimeout(() => {
        setErrorAlert(false)
      }, 30000)
      return
    }

    try {
      const response = await axios.post(url, {
        chat_id: chatId,
        text: message,
      })
      console.log("Message sent:", response.data)
      setSuccessAlert(true)
      setTimeout(() => {
        setSuccessAlert(false)
      }, 30000)
    } catch (error) {
      console.error("Error sending message:", error)
      setErrorAlert(true)
      setTimeout(() => {
        setErrorAlert(false)
      }, 30000)
    }
  }

  async function onSendWaiter() {
    const dataPay = {
      queryId: "0",
      cartItems: [],
      comment: "Send Waiter",
      totalPrice: "-",
      paymentMethod: "-",
      address: "-",
      optionDelivery: "-",

      restaurantId: restaurant_id,

      // optionDelivery: `${query.qr_name}`,
      // user_id: user?.id || 0,
      // user_name: user?.username || "",
    }

    try {
      setButtonDisabled(true)
      setTimeout(() => {
        setButtonDisabled(false)
      }, 5000)

      await axios.post(baseURL + "/create_order_db", dataPay)
      sendMessageTelegram()
    } catch (error) {
      console.error('Ошибка при выполнении запроса "onSendWaiter":', error)
      return
    } finally {
      setFormOpenSendWaiter(false)
    }
  }

  // useEffect(() => {
  //   console.log("user?.language_code :>> ", user?.language_code)
  //   console.log("currentLanguage :>> ", currentLanguage)
  //   if (user?.language_code && user?.language_code !== currentLanguage) {
  //     changeLanguage(user?.language_code)
  //   }
  // }, [user])

  useEffect(() => {
    changeLanguage(language)
  }, [])

  const changeLanguage = (language) => {
    // setCurrentLanguage(language)
    i18n.changeLanguage(language)
    setLanguage(language)
  }
  return (
    <>
      <Button
        sx={{
          position: "absolute",
          top: "0",
          right: "0",
          width: "100px", // Можно настроить ширину в зависимости от вашего дизайна
          // color: "black",
          height: "30px",
          // border: "1px solid black",
        }}
        onClick={toggleTestText}
      ></Button>

      {successAlert && (
        <Box className="notification">
          <Alert severity="success">
            <AlertTitle>Success</AlertTitle>
            The operation was a — <strong>success!</strong>
          </Alert>
        </Box>
      )}

      {errorAlert && (
        <Box className="notification">
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            There was an error sending the message —{" "}
            <strong>please check your Chat ID or try again later!</strong>
          </Alert>
        </Box>
      )}

      {(settings?.logoImage || settings?.businessName) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: 2,
            paddingBottom: 1,
            gap: 2,
          }}
        >
          {settings?.logoImage && (
            <Box
              sx={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                flexShrink: 0,
              }}
            >
              <img
                src={settings.logoImage}
                alt={settings?.businessName || "Business Logo"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          )}
          {settings?.businessName && (
            <Box
              sx={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "white",
                textAlign: "left",
              }}
            >
              {settings.businessName}
            </Box>
          )}
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding : 2

        }}
      >
        <Select
          value={language}
          onChange={(event) => changeLanguage(event.target.value)}
          sx={{
            border: "1px solid orange",
            backgroundColor: theme.blue,
            // width: "150px",
            // margin: 2,
          }}
        >
          {languageButtons.map((button) => (
            <MenuItem key={button.code} value={button.code}>
              <FlexRowContainer>
                <Box>{button.flag} </Box>
                <Box>{button.label}</Box>
              </FlexRowContainer>
            </MenuItem>
          ))}
        </Select>
        {console.log("settings?.showWaiterButton ", settings?.showWaiterButton)}

        {settings?.showWaiterButton === true ? (
          <Button
            disabled={isButtonDisabled}
            onClick={onSendWaiter}
            variant="contained"
            sx={{ padding: "6px" }}
          >
            {t("Call the waiter")}
            <Box className="imageContainer">
              {!isButtonDisabled && (
                <img loading="lazy" src={waiterImg} alt={"waiterImg"} width="50" height="50" />
              )}
            </Box>
          </Button>
        ) : (
          <></>
        )}
      </Box>

      {console.log("settings22333", settings)}
      {console.log("restaurant_id", restaurant_id)}
      {isTestTextVisible && (
        <>
          <p className={"testText"}>{`window.location.href - ${window.location.href}`} </p>
          <p className={"testText"}>{`restaurant_id - ${restaurant_id}`} </p>
          <p className={"testText"}>{`qr_name - ${query.qr_name}`} </p>
          <p className={"testText"}>
            {`navigator.language || navigator.userLanguage - ${navigator.language || navigator.userLanguage}`}{" "}
          </p>
          {/* <p className={"testText"}>
            {`user?.language_code - ${user?.language_code}`}{" "}
          </p> */}
          <p className={"testText"}>{`currentLanguage - ${language}`} </p>
          <p className={"testText"}>{`timeCommitPushed - ${timeCommitPushed}`} </p>
          <p className={"testText"}>{`timeUploadNetlify - ${timeUploadingToNetlify}`}</p>
          <p className={"testText"}>{`gitCommitHash - ${gitCommitHash}`}</p>
          {/* <p className={"testText"}>{`queryId - ${queryId}`}</p> */}
          <p className={"testText"}>
            branch = master ---
            <a href="https://app.netlify.com/sites/burger-web-app/deploys">
              <img
                src="https://api.netlify.com/api/v1/badges/b7a2257c-e7b7-4c1b-8770-02c390f46ab0/deploy-status"
                alt="Netlify Status"
              />
            </a>
          </p>
          <p className={"testText"}>
            branch = dev ---
            <a href="https://app.netlify.com/sites/burger-web-app/deploys">
              <img
                src="https://api.netlify.com/api/v1/badges/b7a2257c-e7b7-4c1b-8770-02c390f46ab0/deploy-status?branch=dev"
                alt="Netlify Status"
              />
            </a>
          </p>
        </>
      )}
    </>
  )
}
